import { styled } from "@linaria/react";
import { colors } from "@/styles/utils/vars";
export const StyledAdminPanel = /*#__PURE__*/styled('section')({
  name: "StyledAdminPanel",
  class: "StyledAdminPanel_sl90l0o"
});

require("./StyledAdminPanel.linaria.module.css!=!../../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js?cacheProvider=!./StyledAdminPanel.tsx");